import { render } from "./AuthorizationContainer.vue?vue&type=template&id=1a7fe134&scoped=true"
const script = {}

import "./AuthorizationContainer.vue?vue&type=style&index=0&id=1a7fe134&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7fe134"]])

export default __exports__